import { Component, Input, OnInit } from '@angular/core';
import * as featureMapping from '../../../../dashboards/services/feature-mapping.json';

@Component({
  standalone: false,
  selector: 'suvo-bi-no-subscription',
  templateUrl: './no-subscription.component.html',
  styleUrls: ['./no-subscription.component.scss'],
})
export class NoSubscriptionComponent implements OnInit {
  @Input() tileInstance: any;

  dataSource: string;
  feature: string;

  ngOnInit() {
    this.feature = featureMapping[this.tileInstance.tileType];
    this.dataSource = this.tileInstance?.recipe?.dataSource;
  }
}
